<template>
  <div>
      <v-row>
        <v-col class="mb-4" cols="12">
          <h4 class="mb-2" style="color:black;">객체 경로</h4>
          <div class="suport_box">
            <strong>객체 경로 추가</strong> <br>
            URLs must start "/" and must exclude wildcards, one per line. Example: /test.html<br>
            The domain is automatically pasted before the entered path<br>
            Available (Chinese mainland): 10000<br>
            Available (outside the Chinese mainland): 10000
          </div>

          <textarea name="input-7-1" placeholder="URLs should start with / (/test/); one URL per line'" class="textarea"></textarea>

        </v-col>
      </v-row>

  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton.vue';

export default {
  components: {
        TextButton,
    },
    data() {
        return {
            modalOpen: false,
        }
    },
    methods: {
      openModal() {
          this.modalOpen = true;
        },
    }
}
</script>

<style lang="scss" scoped>
.textarea {
    width: 100%;
    height: 60px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
}
input:focus  {
    outline: none;
    border: 1px solid #999;
}
</style>